import React from 'react';
import { AlertDialogProvider } from '../context/AlertDialogContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../lib/queryClient';
import { ReactQueryDevtools } from './../../../node_modules/@tanstack/react-query-devtools/src/index';
import { AuthProvider } from './AuthProvider';

const AppProvider = ({ children }: { children: React.ReactNode }) => {
	return (
		<AlertDialogProvider>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>{children}</AuthProvider>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</AlertDialogProvider>
	);
};

export default AppProvider;
